export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const ADD_TO_CART = "ADD_TO_CART";
export const UPDATE_CART_QUANTITY = "UPDATE_CART_QUANTITY";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CLEAR_CART = "CLEAR_CART";
export const GET_STORE_INFO = "GET_STORE_INFO";
export const CLEAR_STORE_INFO = "CLEAR_STORE_INFO";
